import React, { useState, useEffect } from "react";
import { ReactTyped } from "react-typed";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchFaqsContent } from "../redux/features/footerPages/footerPagesContentSlice";

const Faqs = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { faqsContent, status } = useSelector(
    (state) => state.footerPagesContent
  );

  const lang = useSelector((state) => state.language.lang);
  const api_token = localStorage.getItem("api_token");

  const [faqs, setFaqs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState("");
  const [openQuestion, setOpenQuestion] = useState(null);

  useEffect(() => {
    dispatch(fetchFaqsContent({ api_token, lang }));
  }, [lang]);

  useEffect(() => {
    if (status === "fulfilled" && Array.isArray(faqsContent)) {
      setFaqs(faqsContent);

      const uniqueCategories = [
        ...new Set(faqsContent.map((item) => item.faq_type)),
      ];
      setCategories(uniqueCategories);

      if (uniqueCategories.length > 0) {
        setActiveCategory(uniqueCategories[0]);
      }
    }
  }, [status, faqsContent, lang]);

  const toggleQuestion = (question) => {
    setOpenQuestion(openQuestion === question ? null : question);
  };

  return (
    <>
      <div className="container-fluid faq-heading">
        <div className="row">
          <h1 className="text-center">{t("Frequently-Asked-Questions")}</h1>
          <p className="text-center">{t("If-you-dont")}</p>
        </div>
      </div>

      <div className="container faqs">
        {status === "loading" && <p>Loading FAQs...</p>}

        {status === "fulfilled" && faqs.length === 0 && <p>No FAQs found.</p>}

        {categories.length > 0 && (
          <div className="faq-categories">
            {categories.map((category, index) => (
              <button
                key={index}
                className={category === activeCategory ? "active" : ""}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        )}

        <div className="faq-questions">
          {faqs
            .filter((faq) => faq.faq_type === activeCategory)
            .map((faq) => (
              <div key={faq.id} className="faq-item">
                <div
                  className="faq-question"
                  onClick={() => toggleQuestion(faq.faq_title)}
                >
                  <h5>{lang === "de" ? faq.defaq_title : faq.faq_title}</h5>
                  <p>{openQuestion === faq.faq_title ? "-" : "+"}</p>
                </div>

                {openQuestion === faq.faq_title && (
                  <div className="faq-answer">
                    <p>
                      <ReactTyped
                        strings={[
                          lang === "de"
                            ? faq.defaq_description
                            : faq.faq_description,
                        ]}
                        typeSpeed={50}
                        backSpeed={30}
                        showCursor={true}
                        cursorChar="|"
                        startDelay={500}
                      />
                    </p>
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default Faqs;
